import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xl font-bold" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "text-xl font-bold" }
const _hoisted_5 = ["innerHTML"]

import BottomModal from "@/components/template/BottomModal.vue"
  import CardTemplate from "@/components/template/CardTemplate.vue"

  interface Props {
    type: string
    description: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AmvContainer',
  props: {
    type: null,
    description: null
  },
  setup(__props: any) {

const props = __props as {
    type: string
    description: string
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardTemplate, { class: "mx-3" }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(props.type), 1),
      _createElementVNode("p", {
        innerHTML: `${__props.description.slice(0, 300)}${__props.description.length > 300 ? '...' : ''}`
      }, null, 8, _hoisted_2),
      (__props.description.length > 300)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: `${__props.type}_modal`,
            expand: "block",
            class: "opacity-70 underline"
          }, "See more", 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(BottomModal, {
        type: `${__props.type}_modal`
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(props.type), 1),
          _createElementVNode("p", { innerHTML: __props.description }, null, 8, _hoisted_5)
        ]),
        _: 1
      }, 8, ["type"])
    ]),
    _: 1
  }))
}
}

})